<template>
  <PositionDialogs
    :value="isOpen"
    center
    title="Clone Position"
    :message="displayDescription"
    icon="org_icon_position"
    buttonType="magenta"
    actionLabel="Clone"
    @input="onClose"
    @onAction="onClone"
    @onClose="onClose"
  />
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import PositionDialogs from "@components/PositionDialogs/PositionDialogs.vue";

const instance = getCurrentInstance();
const proxy = instance?.proxy;

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  /** @deprecated Use modelValue (Vue 3 v-model). Kept for Vue 2 v-model compatibility. */
  value: {
    type: Boolean,
    default: undefined,
  },
  positionName: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  maxWidth: {
    type: String,
    default: "450",
  },
});

const emit = defineEmits(["update:modelValue", "onAction", "input"]);

const isOpen = computed(() => {
  if (props.modelValue !== undefined && props.modelValue !== false) return props.modelValue;
  if (props.value !== undefined) return props.value;
  return props.modelValue;
});

const displayDescription = computed(() => {
  if (props.description) {
    return props.description;
  }
  const name = props.positionName || "this position";
  return `You are about to clone position ${name}. This will create a clone with the same roles attached.`;
});

function onClone() {
  if (proxy.$loader?.isAppLoading) return;
  emit("onAction");
}

function onClose() {
  if (proxy.$loader?.isAppLoading) return;
  emit("update:modelValue", false);
  emit("input", false);
}

defineExpose({ onClone, onClose });
</script>
